import {Injectable} from '@angular/core';
import {CommercialModel} from '@app/model/dcp-config-service/commercial-model-config';
import {DcpBundleTemplate, DcpPriceDisplayData, DcpPriceDisplayOptionsData, JsonService, TypeValuePair} from '@dcp/configurator';
import {DcpPriceCommitmentPeriodData} from '../../../model/price/dcp-price-commitment-period-data';
import {DcpPriceCommonServicePlanFeaturesData} from '../../../model/price/dcp-price-common-service-plan-features-data';
import {DcpPriceIncludesData} from '../../../model/price/dcp-price-includes-data';
import {DcpPriceRatePlansData} from '../../../model/price/dcp-price-rate-plans-data';
import {DcpPriceRestrictionsData} from '../../../model/price/dcp-price-restrictions-data';
import {DcpPriceServicePlanData} from '../../../model/price/dcp-price-service-plan-data';
import {NavigationLink} from '../navigation-bar/navigation-link';


export const NAV_LINK: NavigationLink = {
  headline: 'productDetails.pricing',
  id: 'plans-and-pricing-section'
};
const SERVICE_PLAN: string = 'servicePlan';
const COMMON_SERVICE_PLAN_FEATURES: string = 'commonServicePlanFeatures';
const INCLUDES: string = 'includes';
const COMMITMENT_PERIOD: string = 'commitmentPeriod';
const RESTRICTIONS: string = 'restrictions';
const PRICE_DISPLAY: string = 'priceDisplay';
const RATE_PLANS: string = 'ratePlans';
const PRICE_DISPLAY_OPTIONS: string = 'options';
const ORDER: string = 'order';
const COMMERCIAL_MODELS: string = 'commercialModels';
const COMMERCIAL_MODEL: string = 'commercialModel';

@Injectable({
  providedIn: 'root'
})
export class PlansAndPricingDataService extends JsonService {

  constructor() {
    super();
  }

  public getServicePlans(data: TypeValuePair[]): DcpPriceServicePlanData {
    return this.getJsonDataValue(data, SERVICE_PLAN);
  }

  public getIncludes(data: TypeValuePair[]): DcpPriceIncludesData[] {
    return this.getJsonDataValue(data, INCLUDES);
  }

  public getCommonServicePlanFeatures(data: TypeValuePair[]): DcpPriceCommonServicePlanFeaturesData[] {
    return this.getJsonDataValue(data, COMMON_SERVICE_PLAN_FEATURES);
  }

  public getCommitmentPeriod(data: TypeValuePair[]): DcpPriceCommitmentPeriodData {
    return this.getJsonDataValue(data, COMMITMENT_PERIOD);
  }

  public getRestrictions(data: TypeValuePair[]): DcpPriceRestrictionsData[] {
    return this.getJsonDataValue(data, RESTRICTIONS);
  }

  public getPriceDisplay(data: TypeValuePair[]): DcpPriceDisplayData {
    const parsedJson: DcpPriceDisplayData = this.getJsonDataValue(data, PRICE_DISPLAY);
    if (parsedJson) {
      const priceDisplayKey: string = Object.keys(parsedJson).find(entry => entry !== PRICE_DISPLAY_OPTIONS);
      return parsedJson[priceDisplayKey];
    }
    return undefined;
  }

  public getPriceDisplayOptions(data: TypeValuePair[]): DcpPriceDisplayOptionsData {
    const parsedJson: DcpPriceDisplayData = this.getJsonDataValue(data, PRICE_DISPLAY);
    if (parsedJson) {
      return parsedJson[PRICE_DISPLAY_OPTIONS] as DcpPriceDisplayOptionsData;
    }
    return undefined;
  }

  public getRatePlans(data: TypeValuePair[]): DcpPriceRatePlansData[] {
    return this.getJsonDataValue(data, RATE_PLANS);
  }

  public getOrder(data: TypeValuePair[]): number {
    return this.getJsonDataValue(data, ORDER);
  }

  public getCommercialModel(data: TypeValuePair[]): CommercialModel {
    return this.getJsonDataValue(data, COMMERCIAL_MODEL) || this.getJsonDataValue(data, COMMERCIAL_MODELS)?.[0];
  }

  public sortBundles(bundleTemplates: DcpBundleTemplate[]) {
    return bundleTemplates.slice().sort(
      (a, b) => this.getOrder(a.data) - this.getOrder(b.data)
    );
  }
}
